<template>
  <v-expansion-panel>
    <BaseDialog
      title="HISTÓRICO DE ALTERAÇÕES"
      v-model="historyDialog"
      width="auto"
    >
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-text-field
            v-model="search"
            outlined
            hide-details
            label="Pesquisar"
            placeholder="Pesquise por Documento, Data(DD/MM/AAAA) ou Responsável"
            append-icon="mdi-magnify"
            @click:append="searchHistory()"
            @keydown.enter="searchHistory()"
          ></v-text-field>
        </v-col>
        <v-col cols="auto">
          <v-tooltip color="blue" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="blue" v-on="on" v-bind="attrs"
                >icon-danger mdi-rotate-180</v-icon
              >
            </template>
            <p class="ma-0 pa-0">
              Para pesquisar por data utilize o formato "DD/MM/AAAA"
            </p>
            <p class="ma-0 pa-0">
              Para pesquisar por documentos extras utilize o formato "Outros:
              descrição"
            </p>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <BaseDataTable
            pagination
            disable-sort
            keyItem="cd_documento_fornecedor"
            :selectable="!view && selectable"
            :headers="historyHeaders"
            :items="histories.data"
            :length="histories.last_page"
            :total="histories.total"
            :page="page"
            :loading="loading"
            :actions="actionHistory"
            @paginate="searchHistory"
            @selected="selectedItems = $event"
            @onView="viewFile"
            @onExcluir="confirmDeleteHistory"
          >
            <template v-slot:[`item.nm_tipo_documento`]="{ item }">
              <div style="width: 100% !important; max-width: 300px !important;">
                <span v-if="item.nm_tipo_documento">{{
                  item.nm_tipo_documento
                }}</span>
                <span v-else
                  ><span class="font-weight-bold">Outros: </span
                  >{{ item.nm_descricao }}</span
                >
              </div>
            </template>
            <template v-slot:[`item.actions2`]="{ item }">
              <v-btn
                class="text-none font-weight-regular elevation-1"
                :disabled="item.arquivo64 == null"
                @click="downloadItem(item)"
              >
                <span>
                  <v-icon small>icon-download</v-icon>
                  Download
                </span>
              </v-btn>
            </template>
          </BaseDataTable>
        </v-col>
      </v-row>
    </BaseDialog>
    <BaseDialog v-model="dialogForm" :title="title" @input="hideDialog">
      <ValidationObserver ref="form" v-if="dialogForm">
        <form @submit.prevent="addList()">
          <v-row no-gutters class="mt-5">
            <v-col cols="5">
              <v-text-field
                outlined
                filled
                disabled
                label="Tipo de Documento"
                :value="
                  formAddFile.nm_tipo_documento
                    ? formAddFile.nm_tipo_documento
                    : 'Outros'
                "
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <BaseInputValidation
                v-model="formAddFile.nm_descricao"
                outlined
                auto-grow
                inputType="textarea"
                placeholder="Digite a descrição"
                rows="1"
                name="Descrição *"
                rules="required|max:300"
                :counter="300"
              ></BaseInputValidation>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="4">
              <BaseDatepicker
                label="Validade do Documento"
                idDatePicker="dt_vencimento"
                v-model="formAddFile.dt_vencimento"
                :key="dateKey"
              ></BaseDatepicker>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="5">
              <BaseInputValidation
                single-line
                show-size
                v-model="formAddFile.arquivo64"
                inputType="file"
                name="Anexo"
                messages="Só é permitido o envio de arquivos nos formatos .PDF, .PNG, .JPG, .JPEG"
                accept="application/pdf,image/png,image/jpeg"
                placeholder="Procurar Arquivo"
                :rules="{
                  required: true,
                  ext: ['jpeg', 'jpg', 'png', 'pdf'],
                  sizeFile: true
                }"
              ></BaseInputValidation>
            </v-col>
            <v-col cols="2">
              <v-btn
                v-if="formAddFile.arquivo64"
                color="white"
                class="ml-2"
                x-large
                @click="verifyFile()"
              >
                <v-icon left size="25">icon-eye</v-icon>
                Visualizar
              </v-btn>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="2">
              <v-btn
                rounded
                large
                type="submit"
                color="#1976d2"
                style="color:white; font-weight: 300"
                >ADICIONAR À LISTA</v-btn
              >
            </v-col>
          </v-row>
        </form>
      </ValidationObserver>
    </BaseDialog>
    <v-expansion-panel-header color="#007BC3">
      <template v-slot:actions>
        <v-icon color="white" class="font-weight-black"> icon-up-arrow </v-icon>
      </template>
      <b class="white--text">DOCUMENTAÇÃO</b>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="mt-6 mb-12">
      <v-row>
        <v-col>
          <v-btn
            class="elevation-0 text-none font-weight-regular"
            color="white"
            @click="showHistoryDialog()"
            ><v-icon class="mr-2">icon-historico</v-icon>Visualizar histórico de
            alterações</v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h1 v-if="!view" class="font-weight-light text-center">
            Clique nos itens abaixo para anexar os arquivos solicitados.
          </h1>
        </v-col>
      </v-row>
      <v-row class="mt-12 mb-6">
        <v-col>
          <BaseDataTable :headers="headers" :items="documents">
            <template v-slot:[`item.nm_tipo_documento`]="{ item }">
              <span v-if="item.nm_tipo_documento">{{
                item.nm_tipo_documento
              }}</span>
              <span v-else
                ><span class="font-weight-bold">Outros: </span
                >{{ item.nm_descricao }}</span
              >
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <div class="d-flex justify-space-between align-center">
                <div>
                  <v-btn
                    v-if="!view && !item.arquivo64"
                    elevation-1
                    style="text-transform: none"
                    @click="showDialog('ADICIONAR ARQUIVO', item)"
                  >
                    <v-icon left>icon-upload</v-icon>
                    Anexar arquivo
                  </v-btn>
                  <div v-else>
                    <v-btn
                      v-if="!view"
                      icon
                      @click="showDialog('EDITAR ARQUIVO', item)"
                    >
                      <v-icon>icon-pencil</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="item.arquivo64"
                      icon
                      @click="downloadItem(item)"
                      ><v-icon>icon-anexo-subtitulo</v-icon></v-btn
                    >
                    <v-tooltip v-else-if="!view" color="blue" top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-on="on" v-bind="attrs" color="red"
                          ><v-icon>mdi-link-variant</v-icon></v-btn
                        >
                      </template>
                      <span
                        >O arquivo não foi encontrado. Tente anexá-lo
                        novamente.</span
                      >
                    </v-tooltip>
                  </div>
                </div>
                <div>
                  <v-btn
                    v-if="!view && item.arquivo64"
                    icon
                    @click="confirmDelete(item)"
                    ><v-icon>icon-lixeira</v-icon></v-btn
                  >
                  <v-tooltip v-if="item.instrucoes" color="blue" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="blue" v-on="on" v-bind="attrs"
                        >icon-danger mdi-rotate-180</v-icon
                      >
                    </template>
                    <span>{{ item.instrucoes }}</span>
                  </v-tooltip>
                </div>
              </div>
            </template>
          </BaseDataTable>
        </v-col>
      </v-row>
      <v-row v-if="!view">
        <v-col>
          <h2 class="font-weight-light text-center">
            Caso precise enviar um documento que não esteja na lista acima,
            <a
              class="font-weight-regular"
              @click="showDialog('ADICIONAR ARQUIVO EXTRA')"
              >CLIQUE AQUI</a
            >
          </h2>
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import api from "../../_api";
import { ValidationObserver } from "vee-validate";
import BaseDatepicker from "@/components/UI/BaseDatepicker";
import BaseInputValidation from "@/components/UI/BaseInputValidation";
import BaseDialog from "@/components/UI/BaseDialog";
import BaseDataTable from "@/components/UI/BaseDataTable";
import moment from "moment";
import _ from "lodash";
import { mapGetters } from "vuex";

export default {
  props: { view: { type: Boolean, default: false } },
  data() {
    return {
      dialogForm: false,
      historyDialog: false,
      cd_fornecedor: null,
      documents: [],
      histories: {},
      formAddFile: {},
      poolDocuments: [],
      selectedItems: [],
      loading: false,
      editedIndex: -1,
      page: 1,
      search: null,
      title: "",
      dateKey: 1,
      fileKey: 1,
      actionHistory: [],
      selectable: false,
      headers: [
        { text: "Descrição", value: "nm_tipo_documento" },
        { text: "Emissão", value: "created_at", format: "date" },
        { text: "Vencimento", value: "dt_vencimento", format: "date" },
        { text: "Anexo", value: "actions" }
      ],
      historyHeaders: [
        {
          value: "actions",
          actions: [
            {
              type: "button",
              click: "onView",
              icon: "icon-eye",
              disabled: item => item.arquivo64 == null,
              options: { fab: true, icon: true, small: true }
            }
          ]
        },
        { text: "Documento", value: "nm_tipo_documento" },
        { text: "Data de Inclusão", value: "created_at", format: "date" },
        { text: "Data de Alteração", value: "updated_at", format: "date" },
        { text: "Responsável", value: "nm_responsavel" },
        { value: "actions2", align: "end" }
      ]
    };
  },
  computed: {
    ...mapGetters({
      me: "$_auth/me"
    })
  },
  async created() {
    if (this.verifyAuth(this.me)) this.cd_fornecedor = this.me.providers[0].id;
    else this.cd_fornecedor = this.$route.params.id;
    this.documents = await api.getDocuments(this.cd_fornecedor);
    if (this.view)
      this.documents = this.documents.filter(d =>
        Object.prototype.hasOwnProperty.call(d, "cd_documento_fornecedor")
      );
  },

  mounted() {
    if (this.$route.query.user_gfs_token) {
      this.actionHistory.push({
        title: "EXCLUIR",
        click: "onExcluir",
        icon: "icon-lixeira"
      });
      this.selectable = true;
    }
  },

  watch: {
    dialogForm(val) {
      this.$emit("hideBar", val);
    },
    historyDialog(val) {
      this.$emit("hideBar", val);
    }
  },
  methods: {
    showDialog(title, document = null) {
      this.title = title;

      if (document) {
        this.editedIndex = this.documents.indexOf(document);
        const arquivo64 = this.documents[this.editedIndex].arquivo64;
        const nm_arquivo = this.documents[this.editedIndex].nm_arquivo;
        let url = null;

        if (typeof arquivo64 == "object") url = arquivo64;
        else if (arquivo64 && nm_arquivo)
          url = this.dataURLtoFile(arquivo64, nm_arquivo);

        this.formAddFile = { ...document };
        this.$set(this.formAddFile, "arquivo64", url);
      } else {
        this.formAddFile = {
          dt_vencimento: "",
          nm_descricao: "",
          arquivo64: null
        };
      }

      this.dateKey++;
      this.dialogForm = true;
    },
    async showHistoryDialog() {
      this.search = null;
      this.historyDialog = true;
      await this.searchHistory();
    },
    async searchHistory(page) {
      this.page = page || 1;
      this.loading = true;
      this.histories = await api.getHistory(this.cd_fornecedor, {
        page,
        search: this.search
      });
      this.loading = false;
    },
    async confirmDeleteHistory() {
      if (this.selectedItems.length == 0)
        this.$store.dispatch("$_notifications/setAlert", {
          message: "Nenhum item foi selecionado.",
          cancelTitle: "OK"
        });
      else {
        await this.$store.dispatch("$_notifications/setAlert", {
          message: "Você deseja apagar os registos selecionados?",
          cancelTitle: "Não",
          actions: [
            {
              title: "Sim",
              action: this.deleteHistory
            }
          ]
        });
      }
    },
    async deleteHistory() {
      await api.deleteHistory(this.cd_fornecedor, {
        documents: this.selectedItems
      });
      await this.searchHistory();
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },
    verifyFile() {
      let reader = new FileReader();
      reader.readAsDataURL(this.formAddFile.arquivo64);
      reader.onload = e => {
        this.viewFile({ arquivo64: e.target.result });
      };
    },
    hideDialog() {
      this.dialogForm = false;
      this.$nextTick(() => {
        this.formAddFile = {};
        this.editedIndex = -1;
      });
    },
    confirmDelete(item) {
      this.$store.dispatch("$_notifications/setAlert", {
        message: "Você deseja mesmo excluir este arquivo?",
        cancelTitle: "Não",
        actions: [
          {
            title: "Sim",
            action: this.delete,
            param: item
          }
        ]
      });
    },
    async delete(item) {
      const index = this.documents.indexOf(item);

      if (item.cd_tipo_documento) {
        this.documents[index].nm_descricao = "";
        this.documents[index].arquivo64 = null;
        this.documents[index].dt_vencimento = "";
        this.documents[index].created_at = "";
      } else this.documents.splice(index, 1);

      this.updatePool(item, "delete");
    },
    async addList() {
      const valid = await this.$refs.form.validate();
      if (!valid) return;

      if (this.editedIndex != -1) {
        this.documents[
          this.editedIndex
        ].nm_descricao = this.formAddFile.nm_descricao;

        if (this.formAddFile.dt_vencimento) {
          this.documents[
            this.editedIndex
          ].dt_vencimento = this.formAddFile.dt_vencimento;
        } else {
          this.documents[this.editedIndex].dt_vencimento = "";
        }
        this.documents[this.editedIndex].created_at = moment();
        if (this.formAddFile.arquivo64) {
          let reader = new FileReader();
          reader.readAsDataURL(this.formAddFile.arquivo64);
          reader.onload = e => {
            this.documents[
              this.editedIndex
            ].nm_arquivo = this.formAddFile.arquivo64.name;
            this.documents[this.editedIndex].arquivo64 = e.target.result;

            this.updatePool(this.documents[this.editedIndex], "insert_update");
            this.hideDialog();
          };
        }
      } else {
        let newItem = {
          nm_descricao: this.formAddFile.nm_descricao,
          created_at: "",
          dt_vencimento: "",
          arquivo64: null
        };
        if (this.formAddFile.dt_vencimento) {
          newItem.dt_vencimento = this.formAddFile.dt_vencimento;
        }
        newItem.created_at = moment();
        if (this.formAddFile.arquivo64) {
          var read = new FileReader();
          read.readAsDataURL(this.formAddFile.arquivo64);
          read.onload = e => {
            newItem.nm_arquivo = this.formAddFile.arquivo64.name;
            newItem.arquivo64 = e.target.result;

            this.documents.push(newItem);
            this.updatePool(newItem, "insert_update");
            this.hideDialog();
          };
        }
      }
    },
    viewFile(item) {
      const typeFile = this.detectMimeType(item.arquivo64);

      if (typeFile === "image") {
        this.viewImage(item);
      } else if (typeFile === "pdf") {
        this.viewPdf(item);
      } else {
        this.messageAlert =
          "Não foi possível identificar o tipo do arquivo, por isso não será possível a sua visualização";
        this.typeFileUndefined = true;
        return false;
      }
    },
    detectMimeType(b64) {
      const mimeType = b64.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)[0];
      let typeFile = null;

      switch (mimeType) {
        case "image/jpeg":
        case "image/png":
        case "image/gif":
          typeFile = "image";
          break;
        case "application/pdf":
          typeFile = "pdf";
          break;
        default:
          break;
      }
      return typeFile;
    },
    viewImage(item) {
      var image = new Image();
      image.src = item.arquivo64;
      var w = window.open("", "", "height=600,width=550");
      if (w != undefined) {
        w.document.write(image.outerHTML);
      } else {
        this.messageAlert =
          "Não foi possível o pop-up, por favor verifique as configurações de bloqueio do navegador";
        this.typeFileUndefined = true;
        return false;
      }
    },
    viewPdf(item) {
      try {
        if (item.arquivo64) {
          var base64 = item.arquivo64.split(",");
          if (!base64[1]) {
            throw new Error(
              "Não foi possível abrir o pop-up, por favor verifique as configurações de bloqueio do navegador"
            );
          }
          base64 = base64[1];
          const byteCharacters = atob(base64);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          var file = new Blob([byteArray], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        } else {
          this.messageAlert =
            "Não foi possível abrir o pop-up, por favor verifique as configurações de bloqueio do navegador";
          this.typeFileUndefined = true;
        }
      } catch (err) {
        this.messageAlert = err.message;
        this.typeFileUndefined = true;
      }
    },
    downloadItem(item) {
      const linkSource = item.arquivo64;
      const downloadLink = document.createElement("a");
      downloadLink.href = linkSource;
      downloadLink.download = item.nm_arquivo;
      downloadLink.click();
    },
    updatePool(doc, type) {
      let i = -1;

      if (doc.cd_documento_fornecedor)
        i = this.poolDocuments.findIndex(
          el => el.cd_documento_fornecedor == doc.cd_documento_fornecedor
        );
      else i = this.poolDocuments.indexOf(doc);

      switch (type) {
        case "delete":
          if (~i) this.poolDocuments.splice(i, 1);
          if (doc.cd_documento_fornecedor)
            this.poolDocuments.push({
              cd_documento_fornecedor: doc.cd_documento_fornecedor,
              delete: true
            });
          break;
        case "insert_update":
          if (~i) this.poolDocuments[i] = doc;
          else this.poolDocuments.push(doc);
          break;
      }
      this.documents = this.documents.slice();
      this.$emit("setFields", { data: { documents: this.poolDocuments } });
    },
    verifyAuth(me) {
      if (_.hasIn(me, "id") && !this.me.password_reset) return true;
      else return false;
    }
  },
  components: {
    BaseDatepicker,
    BaseInputValidation,
    ValidationObserver,
    BaseDialog,
    BaseDataTable
  }
};
</script>

<style scoped>
.v-data-table >>> th:first-child {
  width: 50%;
}

.v-data-table >>> th:last-child {
  width: 235px;
}

.v-btn {
  text-transform: none;
}

.v-card {
  border: 1px solid black;
  border-radius: 10px;
}

.card-title {
  width: 100%;
  border-bottom: 1px solid black;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title .close:hover {
  opacity: 0.3;
  cursor: pointer;
}

.card-title h1 {
  font-size: large;
  font-weight: 500;
}
</style>
